var map = {
	"./fundamentals/en-translateLevelContentData.js": [
		8633,
		633
	],
	"./fundamentals/es-translateLevelContentData.js": [
		1266,
		266
	],
	"./fundamentals/fr-translateLevelContentData.js": [
		2474,
		474
	],
	"./fundamentals/it-translateLevelContentData.js": [
		4691,
		691
	],
	"./fundamentals/pt-translateLevelContentData.js": [
		4250,
		250
	],
	"./fundamentals/tr-translateLevelContentData.js": [
		5280,
		280
	],
	"./html/en-translateLevelContentData.js": [
		2386,
		386
	],
	"./html/tr-translateLevelContentData.js": [
		9035,
		35
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6925;
module.exports = webpackAsyncContext;